import WarningIcon from '@mui/icons-material/Warning';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { ReactElement } from 'react';
import { DetectionRowView } from './types';
import { useTranslation } from 'react-i18next';

interface HeapDetectionTableProps {
  rows: DetectionRowView[];
  emptyMessage: string;
  classLabel: string;
  countLabel: string;
  modelClassLabel: string;
}

export function HeapDetectionTable({
  rows,
  emptyMessage,
  classLabel,
  countLabel,
  modelClassLabel,
}: HeapDetectionTableProps): ReactElement {
  const { t } = useTranslation();

  if (rows.length === 0) {
    return (
      <Box display='flex' alignItems='center' justifyContent='center' padding={2} boxSizing='border-box'>
        <Typography variant='body2' color='text.secondary'>
          {t(emptyMessage)}
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer
      component={Paper}
      variant='outlined'
      sx={{ maxHeight: '100%', overflow: 'auto', borderRadius: 2, boxSizing: 'border-box' }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell width={50} sx={{ backgroundColor: '#f1f1f1ff' }} />
            <TableCell sx={{ backgroundColor: '#f1f1f1ff' }}>
              <Typography>{t(classLabel)}</Typography>
            </TableCell>
            <TableCell sx={{ backgroundColor: '#f1f1f1ff' }}>
              <Typography>{t(modelClassLabel)}</Typography>
            </TableCell>
            <TableCell align='right' sx={{ backgroundColor: '#f1f1f1ff' }}>
              <Typography>{t(countLabel)}</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={`${row.label}-${index}`} hover>
              <TableCell>
                <Box display='flex' alignItems='center' gap={1}>
                  <Box
                    sx={{
                      width: 22,
                      height: 22,
                      backgroundColor: row.color,
                      borderRadius: 1,
                    }}
                  />
                  <WarningIcon color='warning' />
                </Box>
              </TableCell>
              <TableCell>
                <Typography>{t(row.label)}</Typography>
              </TableCell>
              <TableCell>
                <Typography>{t(`heap.modelClasses.${row.modelClass}`)}</Typography>
              </TableCell>
              <TableCell align='right'>
                <Typography>{row.count}</Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
